module.exports = __webpack_public_path__ + "img/Upoad.9b9bce18.svg";